import { Component } from '@angular/core';

@Component({
    template: `
        <h2>An error occurred.</h2>
    `
})
export class GlobalErrorComponent {
}
